export default __webpack_public_path__ + "static/media/edges.89b39ce8.md";